import { styled } from '@mui/material';

export const VideoPlayerStyled = styled('video')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  width: '100%',
  cursor: 'pointer',
}));
